var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrivateRoomsFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 24.155 24.246",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_584",
    "data-name": "\\u7EC4 584",
    transform: "translate(-2137.389 -1781.754)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_583",
    "data-name": "\\u7EC4 583"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_262",
    "data-name": "\\u8DEF\\u5F84 262",
    d: "M2155.864,1789.191q0-1.137-.005-2.273a2.123,2.123,0,0,0-3.063-2c-.967.423-1.929.855-2.912,1.292a6.425,6.425,0,0,1-3.961,7.964v1.772c.078,0,.154.011.229.011.616,0,1.231,0,1.847,0a.711.711,0,0,1,.756.757q.006,1.373,0,2.746a.714.714,0,0,1-.756.758c-.212,0-.423,0-.649,0v1.421h.618a.718.718,0,0,1,.787.773q0,1.408,0,2.818a.714.714,0,0,1-.772.765q-2.77,0-5.54,0a.72.72,0,0,1-.79-.8q0-5.375.006-10.748a.347.347,0,0,0-.265-.386,6.393,6.393,0,0,1,1.477-12.255c.116-.018.23-.041.345-.061h1.089c.423.085.855.14,1.268.26a6.255,6.255,0,0,1,3.595,2.686c.042.065.086.129.141.211l1.732-.767c.454-.2.9-.412,1.364-.6a3.544,3.544,0,0,1,4.872,3.231c.011.805,0,1.61,0,2.414l.009-.005-.1-.064c-.539-.36-.681-.36-1.23,0-.033.022-.066.042-.1.063Zm-12.08,2.507a3.552,3.552,0,1,0-3.552-3.551A3.56,3.56,0,0,0,2143.784,1791.7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_263",
    "data-name": "\\u8DEF\\u5F84 263",
    d: "M2157.275,1789.191q1.969,1.309,3.939,2.62a.727.727,0,0,1,.329.645c0,3.638.006,7.275-.006,10.913a2.577,2.577,0,0,1-2.577,2.579q-2.391.021-4.782,0a2.581,2.581,0,0,1-2.577-2.58c-.01-3.638,0-7.276,0-10.913a.739.739,0,0,1,.348-.658l3.919-2.606-.008-.005v3.933c-.239,0-.451,0-.663,0a.711.711,0,1,0,0,1.419q1.373.006,2.745,0a.711.711,0,1,0,0-1.419c-.217,0-.435,0-.662,0v-3.933Zm-2.836,10.374c0,.922,0,1.845,0,2.767a.717.717,0,0,0,.782.778q1.349,0,2.7,0a.717.717,0,0,0,.783-.777q0-2.767,0-5.535a.72.72,0,0,0-.794-.79q-1.325,0-2.649,0a.727.727,0,0,0-.818.813Q2154.438,1798.192,2154.439,1799.565Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_264",
    "data-name": "\\u8DEF\\u5F84 264",
    d: "M2145.914,1788.147a2.13,2.13,0,1,1-2.118-2.131A2.137,2.137,0,0,1,2145.914,1788.147Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_265",
    "data-name": "\\u8DEF\\u5F84 265",
    d: "M2157.264,1801.679h-1.392v-4.232h1.392Z",
    fill: "currentColor"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateRoomsFilled);
export default __webpack_public_path__ + "static/media/private_rooms_filled.5687665f.svg";
export { ForwardRef as ReactComponent };